module.exports = __webpack_public_path__ + "img/insta-icon.602d10c7.svg";